import { makeStyles } from 'tss-react/mui';

import { dFlex, scrollBar } from '@assets/mixins';

const useStyles = makeStyles()((theme) => ({
  box: {
    background: theme.secondary.s1,
    borderRadius: theme.borderRadius.md,
    width: '100%',

    '& .MuiInputBase-root': {
      height: 44,
      borderRadius: theme.borderRadius.md,
      transition: 'all 0.25s ease-in-out',

      '& .MuiSelect-icon': {
        color: theme.secondary.s3,
      },

      '& .MuiInputBase-input': {
        borderColor: 'transparent',
        borderRadius: theme.borderRadius.md,
      },

      '&:hover .MuiInputBase-input': {
        borderColor: 'transparent',
        color: theme.primary.p2,
      },

      '&.Mui-focused .MuiInputBase-input': {
        borderColor: 'transparent',
        color: theme.primary.p2,
      },

      '&.Mui-focused .MuiOutlinedInput-notchedOutline ': {
        color: theme.primary.p2,
        borderColor: 'transparent',

        '& .MuiSelect-icon': {
          color: theme.primary.p2,
        },
      },

      '&.Mui-focused.MuiInputBase-root': {
        color: theme.primary.p2,
        background: theme.primary.p3,
        borderColor: 'transparent',

        '& .MuiSelect-icon': {
          color: theme.primary.p2,
        },
      },
    },
  },
  select: {
    width: '100%',
    boxShadow: 'none',
    boxSizing: 'border-box',
    borderRadius: theme.borderRadius.md,
    color: theme.secondary.s3,
    background: theme.secondary.s1,
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '24px',
    transition: 'all 0.25s ease-in-out',

    '&& fieldset': {
      border: 'none !important',
    },

    '&:hover': {
      border: 'none !important',
      '&& fieldset': {
        border: 'none !important',
      },
      '& .MuiSelect-icon': {
        color: theme.primary.p2,
        width: 24,
      },
    },
    '&:before': {
      content: 'none',
    },
    '&:after': {
      content: 'none',
    },
    '& .MuiSelect-select': {
      borderRadius: theme.borderRadius.md,
      padding: '16px',
      paddingRight: '34px !important',
      height: '44px !important',
      boxSizing: 'border-box',
      alignItems: 'center',

      '&:hover': {
        color: `${theme.primary.p2} !important`,
      },
    },

    '& .MuiInputBase-inputSizeSmall': {
      height: '40px !important',
      padding: '8px 8px 8px 16px',
    },

    '& .MuiSelect-icon': {
      color: theme.secondary.s3,
      width: 24,
      right: 8,
    },

    '& .MuiSelect-icon.Mui-disabled': {
      opacity: 0.16,
      color: theme.primary.p2,
    },

    '& .MuiOutlinedInput-input.Mui-disabled': {
      opacity: 0.16,
      WebkitTextFillColor: theme.primary.p2,
    },
  },

  dropDown: {
    marginTop: 4,
    background: theme.background.b1,

    ...scrollBar,

    '&::-webkit-scrollbar-thumb': {
      background: theme.primary.p3,
    },
  },
  checkbox: {
    '& .MuiCheckbox-root': {
      color: theme.primary.p3,
      paddingLeft: 0,
    },

    '& .MuiSvgIcon-root': {
      width: '24px',
      height: '24px',
      fill: theme.primary.p3,
      borderRadius: '2px',
    },
  },
  menuItem: {
    height: 56,
    color: theme.primary.p2,
    background: theme.background.b1,

    '&.Mui-selected': {
      backgroundColor: `${theme.secondary.s4} !important`,
    },

    '& $icon': {
      marginRight: 10,
    },
  },
  disabledBox: {
    opacity: 0.6,
    background: theme.secondary.s5,

    '& .MuiInputBase-root': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: 'transparent',
      },

      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: 'transparent',
      },
    },
    '&.Mui-disabled .MuiInput-input': {
      color: theme.primary.p2,
    },

    '& .MuiInputBase-input.MuiOutlinedInput-input.Mui-disabled': {
      WebkitTextFillColor: theme.primary.p2,
    },

    '& .MuiSelect-icon.Mui-disabled': {
      color: theme.primary.p2,
    },
  },
  errorBox: {
    opacity: 1,

    '& .MuiInputBase-root': {
      '& .MuiOutlinedInput-notchedOutline': {
        color: theme.accent.a2,
        borderColor: theme.accent.a2,
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.accent.a2,
        color: theme.accent.a2,
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.accent.a2,
        color: theme.accent.a2,
      },

      '&.MuiInputBase-root.MuiOutlinedInput-root': {
        color: theme.accent.a2,

        '& .MuiSelect-icon': {
          color: theme.primary.p3,
        },
      },
    },
  },
  icon: {
    display: 'flex',
    marginRight: '8px',
  },
  darkBox: {
    background: theme.background.b2,
  },
  darkSelect: {
    background: theme.background.b2,
  },
  iconMenu: {
    ...dFlex(),

    svg: {
      width: 20,
      height: 20,
      borderRadius: theme.borderRadius.xxl,
    },
  },
  subLabel: {
    display: 'inline-block',
    textTransform: 'lowercase',

    '&::first-letter': {
      textTransform: 'uppercase',
    },
  },
  selectTitle: {
    ...dFlex('start'),
    marginBottom: 4,
  },
  item: {
    ...dFlex(),
    gap: 8,
  },
  selectedMenuItem: {
    ...dFlex('start'),
    gap: 8,
  },
  menuIcon: {
    ...dFlex(),
    svg: {
      width: 20,
      height: 20,
      borderRadius: theme.borderRadius.xxl,
    },
  },
}));

export default useStyles;
